import {FC, memo} from "react";

interface ParallaxImageSectionProps {
    id: string;
    imageSrc: string;
}

export const ParallaxImageSection: FC<ParallaxImageSectionProps> = memo(({id, imageSrc}) => {
        return (
            <section
                id={id}
                className="hidden md:block snap-section h-64 sm:h-80 md:h-[calc(100vh-4rem)] bg-cover bg-fixed bg-center"
                style={{backgroundImage: `url(${imageSrc})`}}
                aria-label="Parallax image section"
            />
        );
    }
);

ParallaxImageSection.displayName = 'ParallaxImageSection';